<ng-container *ngIf="isBrowser">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
  <app-language></app-language>
</ng-container>
